import React from 'react';
import './ImageStyleSheet.css';

function uml3() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/umass3.jpeg" className='img-view'/>
        </div>
    )
}

export default uml3
